import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import Tooltip from 'components/Tooltip';
import { modalStore } from 'apps/modals/app';
import ForkFormModal from 'apps/modals/fork';
import { AddToCollectionModal } from 'apps/collection/addToCollection/index';

import {
  Wrapper,
  Stat,
  Button,
  Count,
  IndicatorStyled,
} from './statButtons.styles';

export const StatIndicator = () => (
  <Wrapper>
    <IndicatorStyled />
    <IndicatorStyled />
    <IndicatorStyled />
  </Wrapper>
);

export const StatButtons = withNamespaces()(
  observer(props => {
    const { t, projectManager } = props;
    const { project } = projectManager;

    if (!project) return <StatIndicator />;

    const {
      id,
      name,
      forkCount,
      isStarred,
      starCount,
      collections,
      content,
      contributions,
    } = project;
    const { followersCount, isFollowed, FollowUser, UnFollow } = content;

    const noContributions = contributions?.totalCount === 0;

    const statButtonsList = [
      {
        render: !project.private,
        disabled: noContributions,
        count: forkCount,
        label: <Trans>Fork</Trans>,
        tip: noContributions
          ? t(`Can't fork projects without contributions.`)
          : t('Create a copy and work on your own version of "{{name}}".', {
              name,
            }),
        action: () => {
          // analytics.sendEvent('clicked-fork');
          modalStore.SetModalComponent(ForkFormModal, { projectManager });
        },
      },
      {
        count: starCount,
        label: isStarred ? <Trans>Collected</Trans> : <Trans>Collect</Trans>,
        tip: isStarred
          ? t('You\'ve added "{{name}}" to one of your collections.', {
              name,
            })
          : t('Add "{{name}}" to one of your collections.', { name }),
        action: () => {
          modalStore.SetModalComponent(AddToCollectionModal, {
            projectId: id,
            projectName: name,
            projectCollections: collections,
          });
        },
      },
      {
        count: followersCount,
        label: isFollowed ? <Trans>Following</Trans> : <Trans>Follow</Trans>,
        tip: isFollowed
          ? t(
              'You\'re receiving activity reports from "{{name}}" to your feed and inbox.',
              { name },
            )
          : t('Receive activity reports from "{{name}}" to your inbox.', {
              name,
            }),
        action: () => (isFollowed ? () => UnFollow() : () => FollowUser()),
      },
    ];

    const statButtons = statButtonsList.map((obj, index) =>
      obj?.render === false ? null : (
        <Stat
          key={index}
          data-tip={obj.tip}
          data-for='tooltipStats'
          disabled={obj?.disabled}
          onClick={obj.action}
        >
          <Button disabled={obj?.disabled}>{obj.label}</Button>
          <Count>{obj.count}</Count>
        </Stat>
      ),
    );

    return (
      <Wrapper>
        <Tooltip id='tooltipStats' delayShow={500} />
        {statButtons}
      </Wrapper>
    );
  }),
);

StatButtons.propTypes = {
  project: PropTypes.object,
  followers: PropTypes.number,
  stars: PropTypes.number,
  forks: PropTypes.number,
  t: PropTypes.func,
};
